export const formatTextForImages = (html) => {

  const el = document.createElement('div')
  el.innerHTML = html
  let counter = 0;
  let lastIndex = 0;
  for (let i = 0; i < el.childNodes.length; i++) {
    const l = el.childNodes[i];
    const childType = l.childNodes[0].tagName
    if (childType === 'BR') {
      // DO NOTHING
    } else if (childType === 'IMG') {
      if (counter === 1) {
        el.childNodes[lastIndex].appendChild(el.childNodes[i].childNodes[0])
        el.childNodes[lastIndex].childNodes[0].style.width = '50%'
        el.childNodes[lastIndex].childNodes[1].style.width = '50%'
        counter = 0
      } else {
        lastIndex = i
        counter = 1
      }
    } else {
      counter = 0
    }
  }
  return el.innerHTML
}